<div class="inicio">
    
    
    <pdf-viewer 
        [src]="src" 
        [render-text]="true"
        [original-size]="true"
    >
    </pdf-viewer>
    

</div>    